'use strict';

var Inflections = require('../../common/var/Inflections'),
    addPlural = require('../internal/addPlural'),
    addSingular = require('../internal/addSingular'),
    addIrregular = require('../internal/addIrregular'),
    addUncountable = require('../internal/addUncountable');

var inflectPlurals;

function buildCommonPlurals() {

  inflectPlurals = function(type, str) {
    return Inflections[type] && Inflections[type].inflect(str) || str;
  };

  addPlural(/$/, 's');
  addPlural(/s$/i, 's');
  addPlural(/(ax|test)is$/i, '$1es');
  addPlural(/(octop|fung|foc|radi|alumn|cact)(i|us)$/i, '$1i');
  addPlural(/(census|alias|status|fetus|genius|virus)$/i, '$1es');
  addPlural(/(bu)s$/i, '$1ses');
  addPlural(/(buffal|tomat)o$/i, '$1oes');
  addPlural(/([ti])um$/i, '$1a');
  addPlural(/([ti])a$/i, '$1a');
  addPlural(/sis$/i, 'ses');
  addPlural(/f+e?$/i, 'ves');
  addPlural(/(cuff|roof)$/i, '$1s');
  addPlural(/([ht]ive)$/i, '$1s');
  addPlural(/([^aeiouy]o)$/i, '$1es');
  addPlural(/([^aeiouy]|qu)y$/i, '$1ies');
  addPlural(/(x|ch|ss|sh)$/i, '$1es');
  addPlural(/(tr|vert)(?:ix|ex)$/i, '$1ices');
  addPlural(/([ml])ouse$/i, '$1ice');
  addPlural(/([ml])ice$/i, '$1ice');
  addPlural(/^(ox)$/i, '$1en');
  addPlural(/^(oxen)$/i, '$1');
  addPlural(/(quiz)$/i, '$1zes');
  addPlural(/(phot|cant|hom|zer|pian|portic|pr|quart|kimon)o$/i, '$1os');
  addPlural(/(craft)$/i, '$1');
  addPlural(/([ft])[eo]{2}(th?)$/i, '$1ee$2');

  addSingular(/s$/i, '');
  addSingular(/([pst][aiu]s)$/i, '$1');
  addSingular(/([aeiouy])ss$/i, '$1ss');
  addSingular(/(n)ews$/i, '$1ews');
  addSingular(/([ti])a$/i, '$1um');
  addSingular(/((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)ses$/i, '$1$2sis');
  addSingular(/(^analy)ses$/i, '$1sis');
  addSingular(/(i)(f|ves)$/i, '$1fe');
  addSingular(/([aeolr]f?)(f|ves)$/i, '$1f');
  addSingular(/([ht]ive)s$/i, '$1');
  addSingular(/([^aeiouy]|qu)ies$/i, '$1y');
  addSingular(/(s)eries$/i, '$1eries');
  addSingular(/(m)ovies$/i, '$1ovie');
  addSingular(/(x|ch|ss|sh)es$/i, '$1');
  addSingular(/([ml])(ous|ic)e$/i, '$1ouse');
  addSingular(/(bus)(es)?$/i, '$1');
  addSingular(/(o)es$/i, '$1');
  addSingular(/(shoe)s?$/i, '$1');
  addSingular(/(cris|ax|test)[ie]s$/i, '$1is');
  addSingular(/(octop|fung|foc|radi|alumn|cact)(i|us)$/i, '$1us');
  addSingular(/(census|alias|status|fetus|genius|virus)(es)?$/i, '$1');
  addSingular(/^(ox)(en)?/i, '$1');
  addSingular(/(vert)(ex|ices)$/i, '$1ex');
  addSingular(/tr(ix|ices)$/i, 'trix');
  addSingular(/(quiz)(zes)?$/i, '$1');
  addSingular(/(database)s?$/i, '$1');
  addSingular(/ee(th?)$/i, 'oo$1');

  addIrregular('person', 'people');
  addIrregular('man', 'men');
  addIrregular('human', 'humans');
  addIrregular('child', 'children');
  addIrregular('sex', 'sexes');
  addIrregular('move', 'moves');
  addIrregular('save', 'saves');
  addIrregular('goose', 'geese');
  addIrregular('zombie', 'zombies');

  addUncountable('equipment information rice money species series fish deer sheep jeans');

}

buildCommonPlurals();

module.exports = inflectPlurals;